import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RuleEngineComponent } from './crud-rules/rule-engine.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { RouterModule } from '@angular/router';
import { ManageRulesComponent } from './manage-rules/manage-rules.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { GlobalPolicyRulesComponent } from './global-policy/global-policy-rules.component';

@NgModule({
  declarations: [RuleEngineComponent, ManageRulesComponent, GlobalPolicyRulesComponent],
  imports: [CommonModule, ReactiveFormsModule, NzIconModule, FormsModule, NzCollapseModule, NzTableModule, NzInputModule, NzButtonModule, NzSelectModule, NzCardModule, NzSwitchModule, NzTagModule, RouterModule, NzDividerModule, NzDropDownModule, NzCheckboxModule, NzInputNumberModule, NzSpinModule, NzMessageModule],
  exports: [RuleEngineComponent]
})
export class RuleEngineModule {}


